import { find, get, isEmpty, toLower } from "lodash";
import React, { useState } from "react";
import { Form, Button } from "react-bootstrap";
import { Field, Formik } from "formik";
import * as Yup from "yup";
import { SearchableList, LoaderWrapper } from "../";
import { useDeepEffect, useRequest } from "../../abstracts";
import { addInvestmentCategory, getInvestmentCategory } from "../../services";
import { FieldInput } from "../../components";
import { errors, tranformListToDropdownValues } from "../../utils";

const InvestmentCategoryDropdown = ({ data, onSelect, value, setData }) => {
  const [newInvestmentCategory, setNewInvestmentCategory] = useState();

  const [request, setRequest] = useState({
    method: getInvestmentCategory, //Get function for the investment types
    stopTrigger: !isEmpty(data),
  });

  const { response, loading } = useRequest(request);

  //  Validation schema
  const schema = Yup.object().shape({
    newInvestmentCategory: Yup.string()
      .required(errors.masterInvestmentCategory.required)
      .max(50, errors.masterInvestmentCategory.length)
      .test(
        "newInvestmentCategory",
        errors.masterInvestmentCategory.characters,
        (val) => !checkSplChar(val)
      )
      .test(
        "newInvestmentCategory",
        errors.masterInvestmentCategory.alreadyExist,
        (val) => !alreadyExist(val)
      ),
  });
  //    Supporting functions for Validation

  const checkSplChar = (val) => {
    const format = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/;
    if (format.test(val) === true) return true;
    else return false;
  };

  const alreadyExist = (val) => {
    const temp = data.map((item) => {
      if (toLower(item.label) === toLower(val)) return true;
      else return false;
    });
    return temp.includes(true);
  };
  const keyDown = (e) => {
    if (e.keyCode == 32) {
      e.preventDefault();
      e.target.value += " ";
    }
  };
  // Filter function
  useDeepEffect(
    () => {
      if (!loading) {
        if (newInvestmentCategory) {
          const filteredValue = find(
            response,
            (item) => toLower(item.name) === toLower(newInvestmentCategory)
          );
          onSelect(
            get(filteredValue, "id", ""),
            get(filteredValue, "name", "")
          );
        }
        setData(tranformListToDropdownValues(response || [], "name", "id"));
      }
    },
    [loading],
    true
  );

  const onFormSubmit = (values) => {
    setNewInvestmentCategory(values["newInvestmentCategory"]);
    setRequest({
      ...request,
      stopTrigger: false,
      method: addInvestmentCategory, // Post function to add new classification type
      payload: {
        name: values["newInvestmentCategory"],
        id: 0,
      },
    });
  };

  return (
    <>
      <LoaderWrapper isLoading={loading} loaderText="">
        <Formik
          initialValues={{ newInvestmentCategory: "" }}
          validationSchema={schema}
          validateOnBlur={false}
          validateOnChange={false}
          onSubmit={onFormSubmit}
        >
          {({ handleChange, handleSubmit, values }) => {
            return (
              <>
                <div className="dropdside-custom-dropdown">
                  <div>
                    <SearchableList
                      label="Select an Investment category"
                      options={data}
                      onSelect={onSelect}
                      selectedValue={value}
                    />
                  </div>
                  <div className="line-separator"></div>
                  <Form autoComplete="off" onSubmit={handleSubmit}>
                    <Field
                      label="Add a new Investment category :"
                      name={"newInvestmentCategory"}
                      type="text"
                      value={values["newInvestmentCategory"]}
                      onChange={handleChange}
                      autoComplete="nope"
                      component={FieldInput}
                      placeholder={"Investment category"}
                      onKeyDown={keyDown}
                    />
                    <Form.Group>
                      <Button type="submit">Add</Button>
                    </Form.Group>
                  </Form>
                </div>
              </>
            );
          }}
        </Formik>
      </LoaderWrapper>
    </>
  );
};

export default InvestmentCategoryDropdown;
